import React, { useState } from 'react';
import { QRScanner } from './QRScanner';

interface AddressInputWithQRProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  label?: string;
  style?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
  showQRButton?: boolean;
}

export const AddressInputWithQR: React.FC<AddressInputWithQRProps> = ({
  value,
  onChange,
  placeholder = 'GXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
  disabled = false,
  label,
  style,
  inputStyle,
  showQRButton = true
}) => {
  const [showScanner, setShowScanner] = useState(false);

  const handleQRScan = (scannedAddress: string) => {
    onChange(scannedAddress);
    setShowScanner(false);
  };

  return (
    <div style={style}>
      {label && (
        <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500', fontSize: '14px' }}>
          {label}
          {showQRButton && (
            <button
              type="button"
              onClick={() => setShowScanner(true)}
              disabled={disabled}
              style={{
                marginLeft: '8px',
                padding: '4px 8px',
                fontSize: '12px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1
              }}
              title="Scan QR Code"
            >
              📷 Scan QR
            </button>
          )}
        </label>
      )}
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          style={{
            flex: 1,
            padding: '8px',
            fontSize: '12px',
            fontFamily: 'Courier New, monospace',
            border: '1px solid #ddd',
            borderRadius: '4px',
            ...inputStyle
          }}
        />
        {showQRButton && !label && (
          <button
            type="button"
            onClick={() => setShowScanner(true)}
            disabled={disabled}
            style={{
              padding: '8px 12px',
              fontSize: '14px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.5 : 1,
              whiteSpace: 'nowrap'
            }}
            title="Scan QR Code"
          >
            📷 Scan
          </button>
        )}
      </div>
      {showScanner && (
        <QRScanner
          isOpen={showScanner}
          onClose={() => setShowScanner(false)}
          onScan={handleQRScan}
          title="Scan Stellar Address"
          description="Position the QR code containing a Stellar address within the frame"
        />
      )}
    </div>
  );
};
